<div class="user">
	<i class="fa fa-user mr-5"></i>{{ user | username:withCompany }}
	<a (click)="logout($event)" class="button logout" title="Odhlásit"><span class="fa fa-sign-out"></span></a>&nbsp;
	<a *ngIf="servicedeskUrl" href="{{ servicedeskUrl }}" target="_blank" class="button" title="Podpora"><span class="fa fa-question"></span></a>
</div>
